export default "__VITE_ASSET__676319d9__"